import script from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    staticClass: "v-checkbox",
    class: _vm.classes,
    style: _vm.styles
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.localValue,
      expression: "localValue"
    }],
    staticClass: "v-checkbox__input sr-only",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.localValue) ? _vm._i(_vm.localValue, null) > -1 : _vm.localValue
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.localValue,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.localValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.localValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.localValue = $$c;
        }
      }
    }
  }, 'input', Object.assign({}, _vm.attrs, _vm.$attrs), false)), _vm._v(" "), _c('span', {
    staticClass: "v-checkbox__label"
  }, [_vm.indeterminate ? _c('MinusIcon') : _c('CheckIcon')], 1)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-69570be8_0", {
    source: ".v-checkbox[data-v-69570be8]{display:inline-flex;flex-shrink:0;position:relative}.v-checkbox__label[data-v-69570be8]{background:#fff;border:.125rem solid var(--c-color);border-radius:2px;cursor:pointer;color:var(--c-color);display:inline-flex;align-items:center;justify-content:center;height:1.25em;font-size:var(--c-size);position:relative;transition:all var(--g-transition-speed);width:1.25em}.v-checkbox__label[data-v-69570be8]:before{background:var(--c-bg-color);border-radius:50%;content:\"\";left:50%;height:275%;position:absolute;opacity:0;top:50%;transform:translate(-50%,-50%);transition:inherit;width:275%}.v-checkbox__label svg[data-v-69570be8]{color:currentcolor;font-size:inherit;flex-shrink:0;height:.9em;width:.9em;stroke-width:.125rem;transform:translate(-50%,-50%) scale(0);transition:transform var(--g-transition-speed);position:absolute;top:50%;left:50%}.v-checkbox__input:focus:not(:disabled)+.v-checkbox__label[data-v-69570be8]:before,.v-checkbox__input:not(:disabled)+.v-checkbox__label[data-v-69570be8]:hover:before{opacity:1}.v-checkbox__input:disabled+.v-checkbox__label[data-v-69570be8]{cursor:default;opacity:.75}.v-checkbox--indeterminate .v-checkbox__label svg[data-v-69570be8],.v-checkbox__input:checked+.v-checkbox__label svg[data-v-69570be8]{transform:translate(-50%,-50%) scale(1)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-69570be8";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Checkbox = __vue_component__;
export { Checkbox as default };